/**
 * This is a wrapper component for coupon container to show coupons
 *
 * @module views/components/CouponContainer
 * @memberof -Common
 */
import './CouponContainer.scss';

import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { spreadProps } from '@ulta/core/utils/dom/dom';

import CouponDetails from '../CouponDetails/CouponDetails';

/**
 * Represents a CouponContainer component
 *
 * @method
 * @param {CouponContainerProps} props - React properties passed from composition
 * @returns CouponContainer
*/
export const CouponContainer = function( props ){
  if( !Array.isArray( props.coupons ) || props.coupons.length === 0 ){
    return null;
  }
  return (
    <div className='CouponContainer'>
      <div className='CouponContainer__wrapper'>
        <div className={
          classNames( 'CouponContainer__content', {
            [`CouponContainer__content--bg${props.backgroundColor}`]: props.backgroundColor
          } ) }
        >
          {
            props.coupons.map( ( item, index ) =>(
              <div className={
                classNames( 'CouponContainer__content__coupon', {
                  [`CouponContainer__content__coupon--lastElement`]: ( index % 2 === 0 && props.coupons.length - 1 === index )
                } )
              }
              key={ index }
              >
                <CouponDetails { ...spreadProps( { ...item } ) }/>
              </div>
            ) )
          }
        </div>
      </div>
    </div>
  );
};

/**
 * Property type definitions
 * @typedef CouponContainerProps
 * @type {object}
 * @property {object} coupons - this will display coupon items
 * @property {string} backgroundColor - this will set background color for coupon wrapper
*/
export const propTypes =  {
  coupons: PropTypes.array,
  backgroundColor: PropTypes.string
};

CouponContainer.propTypes = propTypes;

export default CouponContainer;